export const MEDIA_CATEGORIES = [
  "About TENET",
  "The TENET Method",
  "Readiness & Renewal",
  "Programs & Processes",
];

export const formatMediaDuration = (seconds) => {
  if (!seconds) return "Duration pending";
  const minutes = Math.floor(seconds / 60);
  return `${minutes}:${String(seconds % 60).padStart(2, "0")}`;
};

export const formatMediaSize = (bytes) => `${(bytes / (1024 * 1024)).toFixed(1)} MB`;